import * as React from 'react';

const SvgArrow = props => (
  <svg
    height={151.207}
    viewBox="0 0 559.095 151.207"
    width={559.095}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="Group 1879"
      fill="none"
      strokeLinecap="round"
      strokeWidth={2}
    >
      <path
        d="M13.664 135.634S51.343-7.905 317.198 80.494 557.324 5.14 557.324 5.14"
        data-name="Path 4060"
        stroke="#00572c"
      />
      <path
        d="M13.664 140.634S51.343-2.905 317.198 85.494 557.324 10.14 557.324 10.14"
        data-name="Path 4061"
        stroke="#007d30"
      />
      <path
        d="M13.664 131.634s37.679-143.539 303.534-55.14S557.324 1.14 557.324 1.14"
        data-name="Path 4062"
        stroke="#559303"
      />
      <path
        d="m10.591 82.56 2.787 61.303 44.964-48.98"
        data-name="Path 4063"
        stroke="#00572c"
        strokeLinejoin="round"
        strokeWidth={2.00104}
      />
      <path
        d="m7.591 82.56 2.787 61.303 44.964-48.98"
        data-name="Path 4064"
        stroke="#007d30"
        strokeLinejoin="round"
        strokeWidth={2.00104}
      />
      <path
        d="m11.591 85.56 2.787 61.303 44.964-48.98"
        data-name="Path 4065"
        stroke="#559303"
        strokeLinejoin="round"
        strokeWidth={2.00104}
      />
    </g>
  </svg>
);

export default SvgArrow;

